// Helpers compartilhados pelos sub-componentes de Extrato Bancário.
// Extraído de FinanceiroExtratoBancario.tsx durante refactor topológico.

import { fetchAuthSession } from 'aws-amplify/auth';
import type { Transacao } from './types';
import { CLASSIF_AUTO_CONCILIA } from './types';

export async function getToken(): Promise<string> {
  const s = await fetchAuthSession();
  return s.tokens?.idToken?.toString() ?? '';
}

export const fmt = (v: number) =>
  (v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });

export function isConciliada(t: Transacao): boolean {
  if (t.parcela_id || t.lancamento_pagar_id || t.par_transacao_id || t.transferencia_ca_id) return true;
  if (CLASSIF_AUTO_CONCILIA.has(t.classificacao)) return true;
  return false;
}
